import setToken from './set-token';

export default {
  setToken,
};
